'use strict';

const SUSPEND_EVENT = 'jf:layout-animation-suspend';
const RESUME_EVENT = 'jf:layout-animation-resume';
const SCROLL_CLAMP_EVENT = 'jf:scroll-clamp';

let suspendCount = 0;

/**
 * Suspend les effets liés au scroll (ex. auto-hide du header) pendant une animation
 * de layout. Compteur pour gérer les appels imbriqués.
 */
export function suspendLayoutScrollEffects() {
    suspendCount += 1;
    if (suspendCount === 1) {
        document.dispatchEvent(new CustomEvent(SUSPEND_EVENT));
    }
}

/**
 * Reprend les effets liés au scroll après une animation de layout.
 */
export function resumeLayoutScrollEffects() {
    suspendCount = Math.max(0, suspendCount - 1);
    if (suspendCount === 0) {
        document.dispatchEvent(new CustomEvent(RESUME_EVENT));
    }
}

/**
 * Ajuste le scroll après un rétrécissement brutal du document (ex. repli d’une section).
 *
 * @param {number} previousScrollY
 */
export function clampScrollAfterLayoutShrink(previousScrollY) {
    const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const targetScroll = Math.min(previousScrollY, maxScroll);

    if (Math.abs(targetScroll - window.scrollY) <= 1) {
        return;
    }

    window.scrollTo({ top: targetScroll, left: 0, behavior: 'instant' });
    document.dispatchEvent(
        new CustomEvent(SCROLL_CLAMP_EVENT, {
            detail: { scrollY: targetScroll },
        })
    );
}
